import { NotificationsPage } from "./notifications/notifications.page";
import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { RegisterPage } from "./register/register.page";
import { RatingPage } from "./rating/rating.page";

const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "register",
    component: RegisterPage,
  },
  {
    path: "notifications",
    component: NotificationsPage,
  },
  {
    path: "register/:id",
    component: RegisterPage,
  },
  {
    path: "rating/:id",
    component: RatingPage,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: "reload",
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AccessRoutingModule {}
